import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StoreConsumptionSosDto } from '.';

export class GetStoreConsumptionSosResponseModel extends GlobalResponseObject {
    data?: StoreConsumptionSosDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: StoreConsumptionSosDto[]){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}